import { withChartLayout } from 'components/common';
import Report from 'components/features/chart/pre-clinical-manager/report/Report';

const ReportPage = withChartLayout('Report')(Report);
export default ReportPage;
